"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorText = exports.HelperText = exports.LabelStyle = exports.Tag = exports.InputStyle = exports.TagInputContainer = exports.StyleBase = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var colors = _interopRequireWildcard(require("../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "sc-16dp7nh-0"
})(["font-family:'Roboto',sans-serif;line-height:24px;"]);

exports.StyleBase = StyleBase;

var TagInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "TagInputContainer",
  componentId: "sc-16dp7nh-1"
})(["background-color:#ffffff;border-style:solid;border-width:1px;border-color:", ";", " border-radius:4px;padding:0 8px;cursor:text;"], function (props) {
  return props.isFocus ? colors.primary : colors.borderColor;
}, function (props) {
  return props.hasError && (0, _styledComponents.css)(["border-color:", ";"], colors.red);
});

exports.TagInputContainer = TagInputContainer;

var InputStyle = _styledComponents["default"].input.withConfig({
  displayName: "InputStyle",
  componentId: "sc-16dp7nh-2"
})(["width:130px;border:0;font-size:12px;outline:0;padding:7px 0;line-height:24px;"]);

exports.InputStyle = InputStyle;

var Tag = _styledComponents["default"].span.withConfig({
  displayName: "Tag",
  componentId: "sc-16dp7nh-3"
})(["background-color:rgba(96,80,220,0.1);color:", ";font-size:12px;padding-left:8px;font-weight:500;border-radius:2px;margin-right:10px;margin-top:8px;display:inline-block;line-height:24px;span{cursor:pointer;height:24px;width:24px;display:inline-block;text-align:center;path{fill:", ";}}"], colors.primary, colors.primary);

exports.Tag = Tag;

var LabelStyle = _styledComponents["default"].label.withConfig({
  displayName: "LabelStyle",
  componentId: "sc-16dp7nh-4"
})(["margin-bottom:8px;font-size:12px;display:block;"]);

exports.LabelStyle = LabelStyle;

var HelperText = _styledComponents["default"].div.withConfig({
  displayName: "HelperText",
  componentId: "sc-16dp7nh-5"
})(["margin:-8px 0 8px;font-size:12px;color:", ";"], colors.textColor);

exports.HelperText = HelperText;

var ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "ErrorText",
  componentId: "sc-16dp7nh-6"
})(["margin:8px 0 0 8px;font-size:12px;color:", ";line-height:14px;"], colors.red);

exports.ErrorText = ErrorText;